"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _moment = _interopRequireDefault(require("moment"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Check if a date is before or equal to another date, if no specific date is passed todays date will be used.
 * @param message
 * @param fieldID
 * @returns {function({field: *})}
 */
var isDateNotEqualToOrBefore = function isDateNotEqualToOrBefore(message, fieldID) {
  return function (_ref) {
    var field = _ref.field,
        form = _ref.form;

    // This is not an 'isRequired' validator
    if (!field.value) {
      return true;
    }

    var isValid = true;
    var enteredDate = (0, _moment.default)(field.value, 'DD/MM/YYYY');

    if (fieldID) {
      var beforeDateStr = form.$(fieldID).value;

      if (beforeDateStr) {
        var beforeDate = (0, _moment.default)(beforeDateStr, 'DD/MM/YYYY');
        isValid = !enteredDate.isSameOrAfter(beforeDate);
      }
    }

    return [isValid, message];
  };
};

var _default = isDateNotEqualToOrBefore;
exports.default = _default;
//# sourceMappingURL=isDateNotEqualToOrBefore.js.map